/* eslint-disable no-console */
<template>
  <div>
    <div class="card z-depth-5 p-3">
      <div class="d-flex justify-content-between">
        <h4 class="text-center font-weight-bold py-3">Pending Students</h4>    
        <button class="btn btn-primary btn-sm" @click.prevent="downloadCSV()">Download csv</button>
      </div>
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead class="thead-dark">
            <tr>
              <th scope="col">Registration Date</th>
              <th scope="col">Name</th>
              <th scope="col">First Name</th>
              <th scope="col">Last Name</th>
              <th scope="col">Email</th>
              <th scope="col">Age Bracket</th>
              <th scope="col">Level</th>
              <th scope="col">School Grade</th>
              <th scope="col">Type</th>
              <th scope="col">Class</th>
              <th scope="col">Group #</th>
              <th scope="col">City</th>
              <th scope="col">Guardian Name</th>
              <th scope="col">Guardian Email</th>
              <th scope="col">Guardian Phone</th>
              <th scope="col">Address</th>
              <th scope="col">Take Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="student in students" :key="student._id">
              <th>{{ miliToDate(student.date_joined) }}</th>
              <th>{{ student.name }}</th>
              <th>{{ student.first_name }}</th>
              <td>{{ student.last_name }}</td>
              <td>{{ student.email }}</td>
              <td>{{ student.age_bracket }}</td>
              <td>{{ student.level }}</td>
              <td>{{ student.school_grade }}</td>
              <td>{{ student.type }}</td>
              <td>{{ student.class }}</td>
             
              <td>
              <select v-model="student.group">
                <option value = "-1" selected disabled>-- Select A Group --</option>
                <option
                  v-for="group in groups"
                  :key="group._id"
                  v-bind:value="group.group"
                  :selected = "student.group == group.group"
                >
                Group  {{ group.group }}
                </option>
              </select>
              </td>
              <td>{{ student.city }}</td>
              <td>{{ student.guardian_name }}</td>
              <td>{{ student.guardian_email }}</td>
              <td>{{ student.guardian_phone }}</td>
               <td>{{ student.street }} 
              {{ student.interior }} 
              {{student.zip_code}} 
              {{student.state}} 
              {{student.city}} 
              {{student.neighbor}} 
              {{student.references}}</td>
              <td>
                <button
                  class="btn btn-success btn-sm btn-block"
                  @click="paid(student)"
                  v-if="!student.paid"
                >
                  Paid
                </button>
                 <button
                  class="btn btn-grey btn-sm btn-block"
                  v-if="student.paid"
                >
                  Paid
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "PendingStudents",
  components: {
  },
  data() {
    return {
      modalTeacher: false,
      students: [],
      currentStudentId: "",
      teachers: [],
      teacher: "",
      groups: [],
      currentTeacherName: "",
      fastAdminToken: localStorage.getItem("fastAdminToken"),
    };
  },
  methods: {
    getStudentId(student) {
      this.currentStudentId = student._id;
      this.teacher = student.teacher;
      
      for(let item of this.teachers) {
        if(item._id == this.teacher) {
          this.currentTeacherName = item.first_name;
          break;
        }
      }

      this.modalTeacher = true;
    },
    assignTeacher() {
      let data = {
        teacher: this.teacher,
        student: this.currentStudentId,
      };


      const config = {
        headers: {
          Authorization: "Bearer " + this.fastAdminToken,
          "Content-Type": "application/json",
        },
      };
      this.$toast.open({
        message: "Processing : Assigning Teacher To Student Please Wait...",
        type: "info",
      });
      axios
        .post(this.$apiURI + "/enrollment/assign/teacher", data, config)

        .then((response) => {
          if (response.data.error) {
            this.$toast.open({
              message: "Error : " + response.data.message,
              type: "error",
            });
          } else {
            this.$toast.open({
              message: "Teacher Assigned Successfully",
              type: "success",
            });
          }
        })
        .catch((error) => {
          this.$toast.open({
            message: "Error : " + error.response.data.message,
            type: "error",
          });
        });
    },
    activate(account_id) {
      const config = {
        headers: {
          Authorization: "Bearer " + this.fastAdminToken,
          "Content-Type": "application/json",
        },
      };
      this.$toast.open({
        message: "Processing : Activating Account Please Wait...",
        type: "info",
      });
      axios
        .post(this.$apiURI + "/account/" + account_id + "/activate", {}, config)
        .then((response) => {
          if (response.data.error) {
            this.$toast.open({
              message: "Error : " + response.data.message,
              type: "error",
            });
          } else {
            this.$toast.open({
              message: "Account Activated Successfully",
              type: "success",
            });
            window.location.reload();
          }
        })
        .catch((error) => {
          this.$toast.open({
            message: "Error : " + error.response.data.message,
            type: "error",
          });
        });
    },
    paid(student) {
      if (student.group == '-1') {
        this.$toast.open({
        message: "Please select a group first.",
        type: "error",
      });
        return;
      }

      if (!confirm("Are you sure?")) {
        return;
      }

      const config = {
        headers: {
          Authorization: "Bearer " + this.fastAdminToken,
          "Content-Type": "application/json",
        },
      };
      this.$toast.open({
        message: "Processing : Activating Account Please Wait...",
        type: "info",
      });
      axios
        .post(this.$apiURI + "/account/" + student._id + "/paid", {group: student.group}, config)
        .then((response) => {
          if (response.data.error) {
            this.$toast.open({
              message: "Error : " + response.data.message,
              type: "error",
            });
          } else {
            this.$toast.open({
              message: "Account Activated Successfully",
              type: "success",
            });
            window.location.reload();
          }
        })
        .catch((error) => {
          this.$toast.open({
            message: "Error : " + error.response.data.message,
            type: "error",
          });
        });
    },
    remove(account_id) {

      if (!confirm("Are you sure?")) {
        return;
      }


      const config = {
        headers: {
          Authorization: "Bearer " + this.fastAdminToken,
          "Content-Type": "application/json",
        },
      };
      this.$toast.open({
        message: "Processing : Activating Account Please Wait...",
        type: "info",
      });
      axios
        .post(this.$apiURI + "/account/" + account_id + "/remove", {}, config)
        .then((response) => {
          if (response.data.error) {
            this.$toast.open({
              message: "Error : " + response.data.message,
              type: "error",
            });
          } else {
            this.$toast.open({
              message: "Account Activated Successfully",
              type: "success",
            });
            window.location.reload();
          }
        })
        .catch((error) => {
          this.$toast.open({
            message: "Error : " + error.response.data.message,
            type: "error",
          });
        });
    },
    deactivate(account_id) {
      const config = {
        headers: {
          Authorization: "Bearer " + this.fastAdminToken,
          "Content-Type": "application/json",
        },
      };
      this.$toast.open({
        message: "Processing : Disabling Account Please Wait...",
        type: "info",
      });
      axios
        .post(this.$apiURI + "/account/" + account_id + "/deactivate", {}, config)
        .then((response) => {
          if (response.data.error) {
            this.$toast.open({
              message: "Error : " + response.data.message,
              type: "error",
            });
          } else {
            this.$toast.open({
              message: "Account Disabled Successfully",
              type: "success",
            });
            window.location.reload();
          }
        })
        .catch((error) => {
          this.$toast.open({
            message: "Error : " + error.response.data.message,
            type: "error",
          });
        });
    },
    downloadCSV(){

      var jsonData = [];

      for (var i in this.students) {
        jsonData.push({
          'Status': '0',
          'Student id': this.students[i].email,
          'Class': this.students[i].class,
          'Name': this.students[i].name,
          'First name': this.students[i].first_name,
          'Last name': this.students[i].last_name,
          'Gender': this.students[i].gender,
          'Program': this.students[i].age_bracket,
          'Last level': '1',
          'Current level': '1',
          'Type': this.students[i].type,
          'Registration date': this.miliToDate(this.students[i].date_joined),
          'Starting age': '',
          'School grade': '',
          'Termination date': '',
          'Days at FASTMIND': '',
          'Coach': '',
          'Day': this.students[i].class_day,
          'Schedule': '',
          'Group': this.students[i].group,
          'Parent name': this.students[i].guardian_name,
          'Phone 1': this.students[i].guardian_phone,
          'Phone 2': this.students[i].guardian_phone_b,
          'Email 1': this.students[i].guardian_email,
          'Email 2': this.students[i].guardian_email_b,
          'birthdate': this.students[i].birthday,
          'Street & Number': (this.students[i].street || '').replaceAll('#', ''),
          'Interior Number': this.students[i].interior || '',
          'Zip Code': `'${this.students[i].zip_code || 'none'}'`,
          'State': this.students[i].state || '',
          'City': this.students[i].city || '',
          'Neighborhood': this.students[i].neighbor || '',
          'Refereneces': this.students[i].references || '',
        });
      }

      const arr = typeof jsonData !== 'object' ? JSON.parse(jsonData) : jsonData;
      const str = `${Object.keys(arr[0]).map((value) => `${value}`).join(',')}\r\n`;
      let csvContent = arr.reduce((st, next) => {
        st += `${Object.values(next).map((value) => 
          `${value}`).join(',')}\r\n`;
          return st;
        }, str);

      csvContent = csvContent.replaceAll("#", "");
      const element = document.createElement('a');
      element.href = `data:text/csv;charset=utf-8,${encodeURI(csvContent)}`;
      element.target = '_blank';
      element.download = 'pending-students.csv';
      element.click();
    },
    miliToDate(milis) {
      var date = new Date(milis);
      return date.toLocaleString().split(',')[0];
    },
  },

 
  mounted() {
    this.$toast.open({
      message: "Processing : Loading Students Data Please Wait...",
      type: "info",
    });

    const config = {
      headers: {
        Authorization: "Bearer " + this.fastAdminToken,
        "Content-Type": "application/json",
      },
    };
    axios
      .get(this.$apiURI + "/account/pending-students", config)
      .then((response) => {
        if (response.data.error) {
          this.$toast.open({
            message: "Error : " + response.data.message,
            type: "error",
          });
        } else {
          // eslint-disable-next-line no-console
          // console.log(response.data.data.teachers)
          this.students = response.data.data.students;


          axios.get(this.$apiURI + "/groups", config)
          .then((response) => {
              if (response.data.error) {
                  this.$toast.open({
                      message: "Error : " + response.data.message,
                      type: 'error'
                  });
              } else {
                  this.groups = response.data.data.groups
              }

          }).catch((error) => {
              this.$toast.open({
                  message: "Error : " + error.response.data.message,
                  type: 'error'
              });
          });


        }
      })
      .catch((error) => {
        this.$toast.open({
          message: "Error : " + error.response.data.message,
          type: "error",
        });
      });

    axios
      .get(this.$apiURI + "/account/teachers", config)
      .then((response) => {
        if (response.data.error) {
          this.$toast.open({
            message: "Error : " + response.data.message,
            type: "error",
          });
        } else {
          // eslint-disable-next-line no-console
          // console.log(response.data.data.teachers)
          this.teachers = response.data.data.teachers;
        }
      })
      .catch((error) => {
        this.$toast.open({
          message: "Error : " + error.response.data.message,
          type: "error",
        });
      });
  },
};
</script>
